import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAuctionsList, setAuctionTypeFlag, setSearchFlag } from '../../../store/auctions/action';
import { fetchNotifications } from '../../../store/notification/action';
import AuctionList from './component';

const mapStateToProps = ({ auctions: auctionsList, user }) => ({
    auctionsList, user
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getAuctionsListConnect: getAuctionsList,
    setSearchFlagConnect: setSearchFlag,
    fetchNotificationsConnect: fetchNotifications,
    setAuctionTypeFlagConnect: setAuctionTypeFlag
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AuctionList);